import {FC} from 'react';
import {CustomIcon, IconName} from "../../assets/icons";
import {Button} from "@mui/material";

type Props = {
  icon: IconName;
  onClick?: () => void;
  label?: boolean;
};
export const IconButton:FC<Props> = ({icon, onClick, label, children}) => {
  return (
    <Button
      onClick={onClick}
      component={label?"label":null}
      sx={{
      padding: '0',
      border: '1px solid #a8de02',
      width: '54px',
      height: '54px',
      minWidth: '0',
      borderRadius: '50%',
      background: '#ffffff'
    }}>
      <CustomIcon name={icon} styles={{
        width:'24px',
        height: '24px'
      }}/>
      {children}
    </Button>
  )
}
